import React, { useState, useEffect, useRef, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import './ProcessVideo.css';
import { useLocation } from 'react-router-dom';
import MenuItems from '../menubar/MenuItems';
import MobileMenuBar from '../menubar/MobileMenuBar';
import UserDots from '../menubar/UserDots'
import { useDispatch, useSelector } from "react-redux";
import { startTimer, stopTimer, resetTimer } from "./timerSlice";
import axios from "axios";
import videoData from './data/videoData'; // Importing the separated video data
import { getMemoCreateUrl, getUserSessionUrl } from '../constants';
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import ProcessTable from './ProcessTable'
import Logo from '../menubar/Logo'
import { useNavigate } from 'react-router-dom';
import ProcessTableMobile from "./ProcessTableMobile"; // Import Mobile Component
import useMediaQuery from "@mui/material/useMediaQuery";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import ChoppiesChatBot from '../chatbot/ChoppiesChatBot';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#000",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));


function ProcessVideo() {
  const { username, userid, token, logout } = useContext(AuthContext);
  const location = useLocation();
  const { videoProcesses, backgroundImage, backgroundColor,tableWidth} = videoData[location.pathname] || {};
  const [currentVideo, setCurrentVideo] = useState(null);
  const [currentVideoName, setCurrentVideoName] = useState(null);
  const [currentModuleName, setCurrentModuleName] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const startTime = useSelector((state) => state.timer.startTime);
  const [videoDuration, setVideoDuration] = useState(0);
  const videoRef = useRef(null);
  const [pdfSrc, setPdfSrc] = useState('');
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:768px)");


  const handleVideoLoad = () => {
    if (videoRef.current) {
      setVideoDuration(videoRef.current.duration);
    }
  };

  const handlePlayClick = async (process, name) => {
    try {
      const response = await axios.get(getUserSessionUrl(userid), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        // ✅ If session is valid, proceed with opening PDF or playing video
        if (name === 'pdf') {
          setPdfSrc(process.pdf);
          setIsModalOpen(true);
          setCurrentVideoName('Process user pdf');
        } else {
          setCurrentVideo(process.video);
          setCurrentVideoName(process.name);
        }

        setCurrentModuleName(process.moduleName);
        dispatch(startTimer());
      }

    } catch (error) {
      console.error('Session check error:', error);
      if (error.response && error.response.status === 403) {
        logout();
        navigate('/');
      }
    }
  };


  const storeWatchTime = async (watchTime) => {
    try {
      await axios.post(
        getMemoCreateUrl(), // API URL
        {
          userid: userid,
          username: username,
          module: currentModuleName,
          name: currentVideoName,
          video: currentVideo,
          watchTime: watchTime,
          duration: videoDuration
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass token here
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(resetTimer());
    } catch (error) {
      console.error("Error storing watch time:", error);
      if (error.response && error.response.status === 403) {
        logout();
        navigate('/');
      }
    }
  };

  const handlePlayCloseClick = () => {
    if (startTime) {
      let watchTime = Math.round((Date.now() - startTime) / 1000); // Convert to seconds

      // Ensure watchTime does not exceed videoDuration
      watchTime = Math.min(watchTime, videoDuration);

      dispatch(stopTimer());
      console.log("Watch time and duration:", currentVideoName, currentModuleName, watchTime, videoDuration);

      // Call the API function
      if (userid !== "LWAdmin") {
        storeWatchTime(watchTime);
      }
    }

    setCurrentVideo(null);
    setCurrentVideoName(null);
    setCurrentModuleName(null);
    setVideoDuration(0);
  };

  const handlePlayPdfCloseClick = () => {
    if (startTime) {
      let watchTime = Math.round((Date.now() - startTime) / 1000); // Convert to seconds
      dispatch(stopTimer());
      console.log("Watch time and duration for pdf:", currentVideoName, currentModuleName, watchTime, 0);
      // Call the API function
       if (userid !== "LWAdmin") {
        storeWatchTime(watchTime);
      }
    }
    setIsModalOpen(false);
    setCurrentVideoName(null);
    setCurrentModuleName(null);
  };


  const [currentBg, setCurrentBg] = useState(null);

  useEffect(() => {
    if (backgroundImage) {
      const img = new Image();
      img.src = backgroundImage;
      img.onload = () => setCurrentBg(backgroundImage);
    }
  }, [backgroundImage]);



  return (
    <Box className="app-container">
      <Grid container spacing={2} style={{ backgroundColor: `${backgroundColor}` }}>
      {!currentVideo && !isModalOpen && (
        <div className="chatbot-float-container">
          <ChoppiesChatBot moduleName={location.pathname.split("/")[1]} />
        </div>
      )}


        {!isMobile ? (
          <>
            {/* Desktop Left Section */}
            <Grid item xs={6}>
              <Logo />

              <Item style={{ backgroundColor: `${backgroundColor}` }}>
                <UserDots />
                <div className="p-menu-section">
                  <MenuItems />
                </div>
                <div className="process-table-container">
                  <ProcessTable
                    videoProcesses={videoProcesses}
                    handlePlayClick={handlePlayClick}
                    tableWidth={tableWidth} // Pass the tableWidth prop to ProcessTable
                  />
                </div>
              </Item>
            </Grid>

            {/* Desktop Right Section */}
            <Grid
              item
              xs={6}
              style={{
                flex: "1",
                backgroundImage: currentBg ? `url(${currentBg})` : 'none',
                transition: 'background-image 1s ease-in-out',
                backgroundSize: "cover",
                backgroundPosition: "top 20% center",
                paddingTop: "2%",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                paddingLeft: "2%",
                backgroundColor: `${backgroundColor}`
              }}
            >
              {/* Video/PDF logic can go here if needed */}
            </Grid>
          </>
        ) : (
          // ✅ Mobile full-width layout
          <Grid
            item
            xs={12}
            style={{
              backgroundImage: currentBg ? `url(${currentBg})` : 'none',
              transition: 'background-image 1s ease-in-out',
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              paddingTop: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: "0",
              width: "100vw",
              height: "auto",
              backgroundColor: `${backgroundColor}`,
              flexDirection: "column"
            }}
          >

            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
              <MobileMenuBar />
            </div>
            {/* Don’t show MenuItems on mobile */}
            <ProcessTableMobile videoProcesses={videoProcesses} handlePlayClick={handlePlayClick} />

          </Grid>
        )}
      </Grid>


      {currentVideo && (
        <div className={isMobile ? "video-overlay-process-mobile" : "video-overlay"}>
          <video className="video-player" controls autoPlay src={currentVideo} ref={videoRef} onLoadedMetadata={handleVideoLoad} />
          <button className="close-button" onClick={handlePlayCloseClick}>✖</button>
        </div>
      )}
      {isModalOpen && (
        <div className="modal-overlay" onContextMenu={(e) => e.preventDefault()}>
          <div className="modal-content">
            <button className="modal-close-btn" onClick={handlePlayPdfCloseClick}>✖</button>
            <div className="pdf-container" style={{ height: '80vh', overflow: 'hidden' }}>
              <Worker workerUrl="/choppies/pdfjs/pdf.worker.min.js">
                <Viewer fileUrl={pdfSrc} />
              </Worker>
            </div>
          </div>
        </div>
      )}
    </Box>
  );

} export default ProcessVideo;
